import 'slick-carousel';
import { isIE } from '../utilities/is-ms.js';

/**
 * Initialize product slider
 * @param  {String} slider - Main product slider selector
 * @param  {String} thumbs - Thumbs product slider selector
 * @return {Void}
 */

export const init = (slider = '.js-product-slider', thumbs = '.js-product-slider-thumbs') => {
	const config = {
    mobileFirst: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		infinite: false,
		adaptiveHeight: true,
		asNavFor: thumbs,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          swipeToSlide: false,
          draggable: false,
          touchMove: false,
          swipe: false
        }
      },
    ]
	};

	const thumbsConfig = {
    mobileFirst: true,
		dots: false,
		arrows: false,
		infinite: false,
		asNavFor: slider,
		focusOnSelect: true,
    vertical: false,
    slidesToShow: 6,
		slidesToScroll: 1,
    swipe: true,
    swipeToSlide: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 5,
          swipeToSlide: false,
          draggable: false,
          touchMove: false,
          swipe: false,
          vertical: true
        }
      },
    ]
	};

	$(slider)
		.not('.slick-initialized')
		.slick(config);

  $(thumbs)
    .not('.slick-initialized')
    .slick(thumbsConfig);

  // IE lazyload fix
  if (isIE()) {
    $(slider).find('.product__slide img').each(function() {
      const dataSrc = $(this).siblings('source').data('srcset');
      $(this).removeClass('lazyload').removeClass('lazyloaded').attr('src', dataSrc);
    });

    $(thumbs).find('.product__slide img').each(function() {
      const dataSrc = $(this).siblings('source').data('srcset');
      $(this).removeClass('lazyload').removeClass('lazyloaded').attr('src', dataSrc);
    });
  }
};

init();

$(window).on('shopify:section:load', function(event) {
	init();
});
